
export default function Footer() {
  return (
    <footer className="bg-green-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo and Trust Statement */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="https://static.readdy.ai/image/8b93f37d678e65e9c37c50c872b94975/381e684f8d6fce9ebf5debc93083afff.png" 
                alt="ND Insured Logo" 
                className="w-12 h-12 object-contain"
              />
              <div>
                <h3 className="text-xl font-bold text-yellow-400" style={{ fontFamily: 'Playfair Display, serif' }}>
                  ND Insured
                </h3>
                <p className="text-sm text-green-200">Health Insurance Made Simple</p>
              </div>
            </div>
            <p className="text-green-100 text-sm leading-relaxed">
              Trusted by hundreds of families and businesses. Licensed health advisor with personalized service and transparent guidance for all your health insurance needs.
            </p>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-yellow-400" style={{ fontFamily: 'Playfair Display, serif' }}>
              Contact Us
            </h4>
            <div className="space-y-3">
              <a 
                href="tel:5612295893" 
                className="flex items-center space-x-3 text-green-100 hover:text-yellow-400 transition-colors"
              >
                <i className="ri-phone-line text-yellow-400"></i>
                <span>(561) 229-5893</span>
              </a>
              <a 
                href="mailto:nicholasdearaujo1@gmail.com" 
                className="flex items-center space-x-3 text-green-100 hover:text-yellow-400 transition-colors"
              >
                <i className="ri-mail-line text-yellow-400"></i>
                <span>nicholasdearaujo1@gmail.com</span>
              </a>
              <a 
                href="sms:5612295893" 
                className="flex items-center space-x-3 text-green-100 hover:text-yellow-400 transition-colors"
              >
                <i className="ri-message-line text-yellow-400"></i>
                <span>Text Us</span>
              </a>
            </div>
          </div>

          {/* Social Links and Services */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-yellow-400" style={{ fontFamily: 'Playfair Display, serif' }}>
              Follow Us
            </h4>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/nicholas.dearaujo/" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-green-800 rounded-full flex items-center justify-center text-green-100 hover:text-yellow-400 hover:bg-green-700 transition-all"
              >
                <i className="ri-facebook-fill"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-green-800 rounded-full flex items-center justify-center text-green-100 hover:text-yellow-400 hover:bg-green-700 transition-all"
              >
                <i className="ri-linkedin-fill"></i>
              </a>
              <a 
                href="https://www.instagram.com/nd.insured/" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-green-800 rounded-full flex items-center justify-center text-green-100 hover:text-yellow-400 hover:bg-green-700 transition-all"
              >
                <i className="ri-instagram-line"></i>
              </a>
            </div>
            <div className="pt-4">
              <p className="text-sm text-green-200">
                Licensed in 30+ states including FL, TX, CA, NY, and more.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-green-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-green-200 text-sm">
            © 2024 ND Insured. All rights reserved. Licensed Health Insurance Advisor.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-green-200 hover:text-yellow-400 text-sm transition-colors mt-2 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
